// When a session was played, for lists and the session header (SPO-1538).
// The API sends start_time (ISO) and duration (minutes); date is the day
// alone, for sessions without a start time.
import { t, dateLocale } from "i18n";
import { parseDay } from "v2/utils/commandSearch";

const start = (session) =>
  session?.start_time ? new Date(session.start_time) : null;

// The day it was played: "Thu 29 Oct" (with the year when it isn't this
// year), or "" when the session has neither a start time nor a date.
export const sessionDay = (session, now = new Date()) => {
  const day = start(session) || parseDay(session?.date);
  if (!day || Number.isNaN(day.getTime())) return "";
  return day.toLocaleDateString(dateLocale("en-GB"), {
    weekday: "short",
    day: "numeric",
    month: "short",
    ...(day.getFullYear() !== now.getFullYear() && { year: "numeric" }),
  });
};

const clock = (date) =>
  date.toLocaleTimeString(dateLocale("en-GB"), {
    hour: "2-digit",
    minute: "2-digit",
  });

// "18:30", or "" without a start time.
export const sessionStartTime = (session) => {
  const s = start(session);
  return s ? clock(s) : "";
};

// "18:30–19:45" when the length is known, else the start alone.
export const sessionTimeRange = (session) => {
  const s = start(session);
  if (!s) return "";
  const minutes = session.duration;
  if (!(minutes > 0)) return clock(s);
  return `${clock(s)}–${clock(new Date(s.getTime() + minutes * 60000))}`;
};

// "45 min", "2h", "1h 15m", or "" when unknown.
export const formatSessionLength = (minutes) => {
  if (!(minutes > 0)) return "";
  if (minutes < 60) return t("session.hero.duration.minutes", { minutes });
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest
    ? t("session.hero.duration.hoursMinutes", { hours, minutes: rest })
    : t("session.hero.duration.hours", { hours });
};

// The parts of "Thu 29 Oct · 18:30 · 1h 15m" for a list row, without
// empty ones.
export const sessionWhenParts = (session, now) =>
  [
    sessionDay(session, now),
    sessionStartTime(session),
    formatSessionLength(session?.duration),
  ].filter(Boolean);
